import { Component, EventEmitter, Inject, NgZone, OnInit, Output, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { RootService } from 'src/app/shared/services/root.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component'
import { FormErrorService } from '../../shared/form-validation/form-error.service';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { formatDate, isPlatformBrowser } from '@angular/common';
import { PaymentService } from 'src/app/shared/services/razorpaypayment/payment.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { ThankuResponse } from 'src/app/shared/payload-Model/billingFormModel';
import { environment } from '../../../environments/environment';
import { CommonService } from 'src/app/shared/services/common.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { data } from 'jquery';

declare var $;

function _window(): any {
  // return the global native browser window object
  return window;
}
@Component({
  selector: 'app-booking-list',
  templateUrl: './booking-list.component.html',
  styleUrls: ['../profile/profile.component.scss']
})
export class BookingListComponent implements OnInit {



  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  isgensetBooking: boolean = false;
  userData: any;
  breadcrumbData: any = [];
  showPaymentOption: boolean = false;
  closeResult: string;
  amount: any;
  page: any;
  sub: Subscription = new Subscription
  bookingData: any;

  environment1 = environment.s3bucket.url;
  showBookingList: boolean = true;
  heartUrls = {
    empty: '../../../assets/images/Star-unfilled.svg',
    half: '../../../assets/images/Star-unfilled.svg',
    full: '../../../assets/images/Star-filled.svg',
  };
  bookingDataDeatail: any;
  paymentTypeForm: FormGroup;
  VasAmount: any;
  dealerInfo: any;
  sub_lob: any;
  model: any;
  rating: any = 0;
  descriptionReview: any;
  currentLeadData: any;
  dealerData: any;
  reviewData: any = [];
  testDriveData: any = [];
  orderDetailsIndex: any;
  closeResult1: any;

  maximumSize:any=6;
  @ViewChild("productReview", { read: TemplateRef }) productReview!: TemplateRef<any>;
  @ViewChild("dealerReview", { read: TemplateRef }) dealerReview!: TemplateRef<any>;
  @ViewChild("retryPay", { read: TemplateRef }) retryPay!: TemplateRef<any>;

  productReviewData: any;
itemsPerPage: any = 10;
  currentPage: any = 1;
  currentPageBooking: any = 1;
  totalItemsTD: any = 0;
  totalItemsBooking: any = 0
  productDetailList: any;
  itemsperpageconfigurator: any = 9;
  showRetryPopup: boolean = false;
  status: any = "upcoming"
  breadcrumbdata: any = [];
  @ViewChild("trackRefModal", { read: TemplateRef, static: false }) trackRefModal: TemplateRef<any>;

  addressProofList = [
    // { name: "Passport", value: "passport" },
    { name: "Aadhar Card", value: "aadhar_card" },
    // { name: "Ration Card", value: "ration_card" },
    // { name: "Driving License", value: "driving_license" },
    // { name: "Utility Bill", value: "utility_bill" },
  ];
  idProofList = [
    { name: "Pan Card", value: "id_pancard" },
    // { name: "Voter ID Card", value: "id_voter_card" },
  ];
  fileToUploadAddressProof: any = '';
  fileToUploadIDProof: any = '';
  imageURLAddressProof: any = '';
  imageURLIDProof: any = '';
  selectedAddressProof: any = null;
  selectedIDProof: any = null;
  isSecure: boolean = false;
  flag: any = 'moreDetails';
  selectedSubTab: any = 'Bookings';
  productLoaded: boolean = false
  otpOpenModal: any;
  openUrl: boolean;
  activeClass: boolean = false;
  selectedIdDocNo: any = '';
  selectedAddDocNo: any = '';
  showTotalAmount: boolean = false;

  showAmountAlert: boolean = false;
  alertmsg: string;
  totalAmount: number;
  optyData: any;

  showRoomPrice: any = 0;
  showRoomError: boolean = false;
  showEmailError: boolean = false;
  email: any;
  ProgressBarData: any = {};
  statusOfTimeLine: any;
  advReceived: boolean = false;

  modalReference: NgbModalRef;
  showTimeLine: boolean = false;

  kycAddOne: any;
  kycAddrTwo: any
  showEdd: boolean = false;
  loadAPI: Promise<any>;
  isMobile: boolean = false;
  payMessage: any;

  payData: any;
  payType: any;
  showerror: boolean = false;
  vasDataLocal: any = {};
  configuratorid: any = [];

  navigatepath: any;
  removeslash: any;
  config: any;
  isAllowToEdit: boolean = false;
  userAadharno:any;
  Dealer_info: any;
  Lead_Status_info:any=[];
  Review_status:any=[];
  RazorPayDetail: any=[];
  optyArray:any = [];
  solrDataArray:any = [];
  messagedata: string;
  schemeDealeCodes = ['1009590','1009460', '1001850','100B780','1007960','1009061','1001770','1009050','1009000','1000480','1008870', '1002600','100B710','100A150','1004850','100B540','1003530']

  schemeMsg: string;
  loyalPoints: any = [];
  loyalityborder: boolean = false;
  constructor(private toastrService: ToastrService, private apiService: ApiService,
    private activatedRoute: ActivatedRoute, private secureService: RootService,
    private paymentService: PaymentService, private ngZone: NgZone,
    private fb: FormBuilder, private regexService: RegexService, private router: Router,
    private spinner: NgxSpinnerService, private modalService: NgbModal, public skeletonService: SkeletonService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private commonService:CommonService,
    private localStorage: secureStorage, private formErrorService: FormErrorService,
    private cleverService: ClevertapService) {
    this.loadAPI = new Promise((resolve) => {
      this.regexService.loadScript();
      resolve(true);
    });
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {

    $('.header').addClass('p-scroll');
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
       this.maximumSize=6

        // some code..
      } else {
        this.isMobile = false;
        this.maximumSize=6
      }
    }
      this.getUserDetails()
    this.userData = this.secureService?.getUserData();

    
if (isPlatformBrowser(this.platformId)) {
      let dealercdforloyality = localStorage.getItem('dealercd');
}
      // this.loyalityborder = this.schemeDealeCodes.includes(dealercdforloyality) ? true : false
    
       this.currentPageBooking = 1
      this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });
  }

  getUserDetails() {
  
    let res = this.secureService.isLoggedIn();
    if (res) {
      this.sub.add(this.apiService.getUserData().subscribe({
        next: (response: any) => {
          if (response?.data?.user_documents) {
            this.userAadharno=response?.data?.user_documents.filter((res)=>{
              return  res?.document_description == 'aadhar_card'
              })
          }
        },
        error: () => {
        },
      })
      );
    }
  
  }

  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }
  getBookingDetails(reqBody: any) {


      try {
        this.spinner.show();
        this.breadcrumbData = ['account', 'bookings']
        this.sub.add(this.apiService.getLeadsnew(reqBody).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.bookingData = response.data.leads;
              this.optyData = response?.data;

              this.optyArray = [];
                this.bookingData.forEach(element => {
                  if (element?.opty_id) {
                  this.optyArray.push(element?.opty_id)
                  }
                });
                this.getSolrData(this.optyArray)
              this.totalItemsBooking = response.range_info.total_count;
              if (isPlatformBrowser(this.platformId)) {
              window.scroll(0, 0);
              }
              this.spinner.hide();
            }
            else {
              this.bookingData = [];
              this.totalItemsBooking = 0
              this.spinner.hide();
              this.toastrService.warning(response.data.msg)
            }
          },
          error: () => {
            this.toastrService.warning("Something went wrong!")
            this.spinner.hide();
          },
          complete: () => {
            this.spinner.hide();
            this.getLoyalStatement();
          }
        }))
      } catch (error) {
        this.spinner.hide();
      }
    
  }
  getDealerData(data: any, flag: any) {
    var json = {}
    if (flag == 'dealer') {
      this.dealerData = data
      json = {
        "action_type": "dealer",
        "is_customer_rating": true,
        "organization_id": this.dealerData.dealer_info.organization_id
      }
    }
    else if (flag == 'product') {
      json = {
        "product_id": data.product.id,
        "action_type": "product",
        "is_customer_rating": true
      }

    }
    this.sub.add(this.apiService.getRatings(json).subscribe({
      next: (res: any) => {
        if (res.success) {
          if (res?.data?.length > 0) {
            if (flag == 'dealer') {
              this.reviewData = res?.data;

                this.openPopup(this.dealerReview)
            }
            else if (flag == 'product') {
              var json = {
                overall: res?.data[0]?.rating_master.find((e: any) => {
                  if (e.parameter == "overall") {
                    return e?.rating
                  }
                }),
                performance: res?.data[0]?.rating_master.find((e: any) => {
                  if (e.parameter == "performance") {
                    return e?.rating
                  }
                }),
                safety: res?.data[0]?.rating_master.find((e: any) => {
                  if (e.parameter == "safety") {
                    return e?.rating
                  }
                }),
                comfort: res?.data[0]?.rating_master.find((e: any) => {
                  if (e.parameter == "comfort") {
                    return e?.rating
                  }
                }),
                design: res?.data[0]?.rating_master.find((e: any) => {
                  if (e.parameter == "design") {
                    return e?.rating
                  }
                }),
                ratingPresent: true,
                productId: data?.product.id,
                title: res?.data[0]?.title,
                description: res?.data[0]?.description,
                image: res?.data[0]?.image[0],
                model: this.productDetailList.model,
                mainImage: this.productDetailList?.images[0]?.image_url
              }
              this.productReviewData = json;

              this.openPopup(this.productReview);
            }

          }
          else {
            if (flag == 'dealer') {
              this.reviewData = [];
              this.openPopup(this.dealerReview)

            }
            else if (flag == 'product') {
              var json1 = {
                overall: 0,
                performance: 0,
                safety: 0,
                comfort: 0,
                design: 0,
                ratingPresent: false,
                productId: data.product.id,
                title: '',
                description: '',
                image: '',
                model: this.productDetailList.model,
                mainImage: this.productDetailList?.images[0]?.image_url
              }
              this.productReviewData = json1;
              this.openPopup(this.productReview);
            }
          }
        }
        else {
          this.toastrService.warning(res.data.msg);
        }
      },
      error: () => {

      }
    }))
  }
  getVehicleDetail(inputData: any) {
    let data = {
      product_id: inputData.product.id
    }
    this.sub.add(this.apiService.getVehicleDetails(data).subscribe({
      next: (res: any) => {
        this.productDetailList = res?.data
        this.getDealerData(inputData, 'product');

      },
      error: () => { },
      complete: () => { }
    }))
  }


  copyMessage(val) {
    if (isPlatformBrowser(this.platformId)) {
    navigator.clipboard.writeText(val)
    }
  }

  showVasBtn(leadData: any) {
    let TmlVasPayment: any = leadData?.razor_pay_detail
    if (TmlVasPayment?.length > 1) {
      return false;
    } else {
      if (leadData?.vas_data?.length > 0 && TmlVasPayment?.length == 1) {
        TmlVasPayment?.forEach((element: any) => {
          if (element.payment_gt_type == "RAZORPAY") {
            return true;

          } else {
            return false;

          }
        });
      } else if (TmlVasPayment?.length == 0) {
        return;
      }
    }
  }

  makeVASPayment(leadData: any) {
    if (leadData?.payment_status == 'Payment Confirmed' && leadData?.vas_data?.length > 0) {
      let TmlVasPayment = leadData?.tml_pay_detail
      let VasleadData = leadData?.vas_data[0]
      this.spinner.show();
      let vas_data = {
        "payment_gateway_type": "RAZORPAY",
        "vas_category": VasleadData?.vas_category,
        "vas_payble_amount": VasleadData?.vas_payble_amount ? Number(VasleadData?.vas_payble_amount) : 0,
        "chassis_number": "",
        "vc_number": VasleadData?.vehicle_number,
        "application": VasleadData?.application,
        "terrian": VasleadData?.terrian,
        "avg_monthly_km": VasleadData?.avg_monthly_km,
        "no_of_years": (VasleadData?.no_of_years).toString(),
        "quantity": VasleadData?.quantity,
        "channel": VasleadData?.channel,
        "fuel_type": VasleadData?.fuel_type,
        "retry_payment": 'True',
        "vas_id": VasleadData?.id,
        "division_id": leadData?.division_id,
        "recommended_quantity": VasleadData?.recommended_quantity,
      }

      if (TmlVasPayment?.length > 1) {
        if (leadData.vas_data?.length > 0) {
          TmlVasPayment?.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY" && VasleadData?.id) {
              this.payType = 'RAZORPAY';
              this.payData = element;
              return;
            } else {
              this.payType = 'ccavenue';
              this.payData = element;
            }
          });
        }
      } else {
        if (leadData.vas_data?.length > 0 && TmlVasPayment?.length == 1) {
          TmlVasPayment?.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              this.payType = 'RAZORPAY';
              this.payData = element;
            } else {
              this.payType = 'ccavenue';
              this.payData = element;
              return;
            }
          });
        } else if (TmlVasPayment?.length == 0) {
          this.toastrService.error('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
          return;
        }
      }

      this.payMessage = "Request In Process";

      this.sub.add(this.apiService.generateVasLead(vas_data).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.spinner.hide();
            let razororderDetails = {
              razorpay_account_id: response.data.razorpay_account_id,
              razorpay_access_key: response.data.razorpay_access_key,
              order_id: response.data.payment_order_id,
              pay_amount: response.data.payment_amount,
              product_name: leadData.product.pl,
              product_description: leadData.product.vehicle_number,
              shopping_order_id: response.data.lead_order_or_vas_row_id,
              email: response.data.email_id,
              contact: response.data.mobile_number,
            };
            this.close();
            this.payWithRazor(razororderDetails, leadData.product, response.data);
            this.toastrService.success(response.data.msg);
          }
          else {
            this.spinner.hide();
            this.toastrService.warning(response.data.msg)
          }
        },
        error: () => {
          this.toastrService.warning("Something went wrong!")
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      }))
    }
  }

  getTotalAmount(leads) {
    let finalAmt = leads?.payment_info?.length > 0 ? leads?.payment_info?.amount : leads?.product?.down_payment * leads?.quantity
    let mainTotalAmount;
    if (leads.vas_data?.length > 0) {
      let VasAmount = Number(leads.vas_data[0].vas_payble_amount);
      mainTotalAmount = finalAmt + VasAmount;
    } else {
      mainTotalAmount = finalAmt
    }
    // return mainTotalAmount;
    return leads?.payment_info?.trans_total_amount ? (leads?.payment_info.trans_total_amount/100) : (leads?.product?.down_payment * leads?.quantity)
  }
  Payment(leads,division_id) {

    this.showRetryPopup = false;
    this.getrazorpaydetail(leads,division_id)
    // if ((leads?.payment_status == 'aborted' || leads?.payment_status == 'Payment Failed'
    //   || leads?.payment_status == 'PENDING' || leads?.payment_status == 'UNBILLED') &&
    //   (leads?.opty_status == 'C1 (Quote Tendered)' || leads?.opty_status == 'C1A (Papers submitted)'
    //     || leads?.opty_status == 'PENDING')
    // ) {
    //   this.leadData(leads)
    // }
    // else {
    //   this.refreshPaymemt(leads);
    // }
  }
  leadData(leads: any,razorpay_Detail:any) {
    let payload = {
      offset: 0,
      limit: 10,
      lead_channel: '',
      request_id: leads?.row_id,
    };
    this.sub.add(
      this.apiService.getLeads(payload).subscribe({
        next: (response: any) => {
          if (response.success) {
            let data = response?.data?.leads[0];
            this.currentLeadData = data;
          }
        },
      })
    );
    // this.currentLeadData = leads;
    if (leads?.payment_status == 'UNBILLED' && razorpay_Detail?.length == 0) {
      this.toastrService.warning('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
      return;
    }
    else if (razorpay_Detail?.length == 0) {
      this.toastrService.warning('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
      return;
    }
    else {
      this.openPopup2(this.retryPay);
      this.paymentTypeForm = this.fb.group({
        paymentType: [razorpay_Detail?.length > 0 ? (razorpay_Detail[0].payment_gt_type)?.toLowerCase() : 'razorpay'],
        amount: [leads?.payment_info?.amount ? (leads?.payment_info?.amount / leads?.quantity) :
          (leads?.product?.down_payment)]
      });
      let finalAmt = leads?.payment_info?.trans_total_amount ? leads?.payment_info?.trans_total_amount/100 : leads?.product?.down_payment * leads?.quantity

      if (leads.vas_data?.length > 0) {
        this.VasAmount = Number(leads.vas_data[0].vas_payble_amount);
      } else {
        this.VasAmount = 0;
        // this.totalAmount = finalAmt
        if (leads?.payment_info) {
          this.totalAmount = finalAmt
        }
        else
        {
          this.totalAmount = finalAmt + this.VasAmount;
        }
      }
      this.showRetryPopup = true;
      this.openPopup2(this.retryPay);
      if (razorpay_Detail?.length > 1) {
        if (leads.vas_data?.length > 0) {
          this.showPaymentOption = false;

          razorpay_Detail.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              // this.totalAmount = finalAmt + this.VasAmount;
              if (leads?.payment_info) {
                this.totalAmount = finalAmt
              }
              else
              {
                this.totalAmount = finalAmt + this.VasAmount;
              }
              this.paymentTypeForm.controls['paymentType'].setValue('ccavenue');
              this.paymentTypeForm.get("paymentType").updateValueAndValidity();
              return;
            }
          });
        } else {

          // this.totalAmount = finalAmt + this.VasAmount;
          if (leads?.payment_info) {
            this.totalAmount = finalAmt
          }
          else
          {
            this.totalAmount = finalAmt + this.VasAmount;
          }
          this.paymentTypeForm.controls['paymentType'].setValidators([Validators.required])
          this.paymentTypeForm.updateValueAndValidity();
          this.showPaymentOption = true;
        }
      } else {
        if (leads.vas_data?.length > 0 && razorpay_Detail?.length == 1) {
          razorpay_Detail.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              // this.totalAmount = finalAmt
              if (leads?.payment_info) {
                this.totalAmount = finalAmt
              }
              else
              {
                this.totalAmount = finalAmt + this.VasAmount;
              }
              this.showPaymentOption = false;
              this.paymentTypeForm.controls['paymentType'].setValue('razorpay');
              this.paymentTypeForm.get("paymentType").updateValueAndValidity();
              return;
            } else {
              this.showPaymentOption = false;
              // this.totalAmount = finalAmt + this.VasAmount;
              if (leads?.payment_info) {
                this.totalAmount = finalAmt
              }
              else
              {
                this.totalAmount = finalAmt + this.VasAmount;
              }
              this.paymentTypeForm.controls['paymentType'].setValue('ccavenue');
              this.paymentTypeForm.get("paymentType").updateValueAndValidity();
              return;
            }
          });
        } else if (razorpay_Detail?.length == 0) {

          // this.totalAmount = finalAmt + this.VasAmount;
          if (leads?.payment_info) {
            this.totalAmount = finalAmt
          }
          else
          {
            this.totalAmount = finalAmt + this.VasAmount;
          }
          this.toastrService.error('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
          return;
        }
      }
    }
  }
  refreshPaymemt(leads,razorpay_Detail) {
    let payload = {
      offset: 0,
      limit: 10,
      lead_channel: '',
      request_id: leads?.row_id,
    };
    this.sub.add(
      this.apiService.getLeads(payload).subscribe({
        next: (response: any) => {
          if (response.success) {
            let data = response?.data?.leads[0];
            this.currentLeadData = data;
          }
        },
      })
    );
    if (leads.payment_info?.razorpay_order_id) {
      this.showRetryPopup = false;

      let request = { "id": leads.payment_info?.razorpay_order_id };

      this.sub.add(this.apiService.getrefreshPayment(request).subscribe({
        next: (data: any) => {

          if (data.data.payment_status == 'aborted') {
            // this.currentLeadData = leads;


            this.paymentTypeForm = this.fb.group({
              paymentType: [razorpay_Detail?.length > 0 ? (razorpay_Detail[0].payment_gt_type)?.toLowerCase() : 'razorpay'],
              amount: [leads?.payment_info?.amount ? (leads?.payment_info?.amount / leads?.quantity) :
                (leads?.product?.down_payment)]
            });
            if (razorpay_Detail?.length > 1) {
              const data = this.paymentTypeForm.get("paymentType");
              data.setValidators([Validators.required]);
              data.updateValueAndValidity();
            }
            if (leads?.payment_status == 'initialized') {
              this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });

            }
          }
          else {
            this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });

            this.toastrService.warning("Payment is under process please wait for some time.")

          }
          if (isPlatformBrowser(this.platformId)) {
            window.scroll(0, 0)
          }
        },
        error: () => {
          this.toastrService.warning("Something went wrong!")
        },
        complete: () => {
        }
      })
      );
    } else {
      // this.toastrService.warning("Payment is under process please wait for some time.")
      this.showRetryPopup = false;
      this.leadData(leads,razorpay_Detail)

      // this.currentLeadData = leads;
      this.paymentTypeForm = this.fb.group({
        paymentType: [razorpay_Detail?.length > 0 ? (razorpay_Detail[0].payment_gt_type)?.toLowerCase() : 'razorpay'],
        amount: [leads?.payment_info?.amount ? (leads?.payment_info?.amount / leads?.quantity) :
          (leads?.product?.down_payment)]
      });
      if (razorpay_Detail?.length > 1) {
        const data = this.paymentTypeForm.get("paymentType");
        data.setValidators([Validators.required]);
        data.updateValueAndValidity();
      }
    }
  }

  payWithRazor(orderDetails: any, vehicleData: any, leadInfo: any) {

    const ResponseData: PaymentResponse = {} as PaymentResponse;
    const options: any = {
      key: orderDetails.razorpay_access_key,
      amount: orderDetails.pay_amount,
      currency: "INR",
      name: vehicleData.product_name, //'VSS', // company name or product name
      description: vehicleData.product_description, //'Star City Bus',  // product description
      image: "https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/tataMLogo.webp", // company logo or product image
      order_id: orderDetails.order_id, // order_id created by you in backend
      //  account_id: orderDetails.razorpay_account_id,
      prefill: {
        email: orderDetails.email,
        contact: orderDetails.contact,
      },
      modal: {
        escape: false,
      },
      notes: {
        shopping_order_id: orderDetails.shopping_order_id,
      },
      theme: {
        color: "#0c238a",
      },
    };
    options.handler = (response: any) => {
      this.payMessage =
        "Your payment of ₹" +
        ((leadInfo.vas_info.vas_total_amount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- received against Request ID " +
        orderDetails.shopping_order_id +
        ".";
      options.response = response;
      ResponseData.razorpay_payment_id = response.razorpay_payment_id;
      ResponseData.razorpay_order_id = response.razorpay_order_id;
      ResponseData.razorpay_signature = response.razorpay_signature;
      this.sub.add(this.apiService.getPaymentDetail(ResponseData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.clevertapPayementFailed();
            const objthank: ThankuResponse = {} as ThankuResponse;
            objthank.headMessage = "Thank You !";
            objthank.payMessage = this.payMessage;
            objthank.vehicleID = vehicleData["id"];
            objthank.vehicleModel = vehicleData["model"];
            objthank.orderAmount = leadInfo.vas_info.vas_total_amount / 100
            objthank.leadInfo = leadInfo;
            objthank.orderId = leadInfo?.lead_info.lead_payment_order_id;
            objthank.reqId = leadInfo?.lead_info.row_id;
            objthank.transactionStatus = 'success';
             if (isPlatformBrowser(this.platformId)) {
            this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
          
              try {
              } catch { }
            }
            this.modalService.dismissAll();

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          } else {
            this.modalService.dismissAll();

            this.clevertapPayementFailed();
            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          }
        }
      }));
      // call your backend api to verify payment signature & capture transaction
    };
    options.modal.ondismiss = () => {
      this.payMessage =
        "Your payment against Request ID " +
        orderDetails.shopping_order_id +
        " of ₹" +

        ((leadInfo.vas_info.vas_total_amount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- is not received.";
      // this.isVerifyOtp = true;
      const objthank: ThankuResponse = {} as ThankuResponse;
      objthank.headMessage = "Sorry !";
      objthank.payMessage = this.payMessage;
      objthank.vehicleID = vehicleData["id"];
      objthank.leadInfo = leadInfo;
      objthank.orderId = leadInfo.payment_order_id;
      objthank.reqId = leadInfo?.lead_info.row_id;
      objthank.vehicleModel = vehicleData["model"];
      objthank.orderAmount = leadInfo.vas_info.vas_total_amount / 100
      objthank.payment_gateway = "RAZORPAY";

if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
}
      const ResponseDatas: PaymentResponse = {} as PaymentResponse;
      ResponseDatas.razorpay_order_id = orderDetails.payment_order_id;
      this.sub.add(this.apiService.getPaymentCancelDetail(ResponseDatas).subscribe({
        next: (response: any) => {
          if (isPlatformBrowser(this.platformId)) {
            try {
            } catch { }
          }
          if (response.success) {
            this.modalService.dismissAll();

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          } else {
            this.modalService.dismissAll();

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          }
        }
      }));
    };
    if (isPlatformBrowser(this.platformId)) {
    const rzp = new this.nativeWindow.Razorpay(options);
    rzp.open();
    }
    return ResponseData;
  }
  submitPaymentMode(leadsData) {
    this.amount = this.paymentTypeForm.value.amount;
    if (this.paymentTypeForm.status == 'INVALID') {
      this.formErrorService.displayFormErrors(this.paymentTypeForm);
      return;
    }
    var payamount = leadsData?.product?.down_payment;
    if (this.amount < payamount) {
      this.showAmountAlert = true;
      this.alertmsg =
        "Down payment should be greater than ₹" +
        this.numberWithCommas(payamount);
      return;
    }
    this.showRoomPrice = leadsData?.ex_showroom_price ? Math.round(leadsData?.ex_showroom_price)
      : leadsData?.product?.price_range ? leadsData?.product?.price_range : 0;
    if (this.showRoomPrice !== 0 && (this.totalAmount > (this.showRoomPrice * leadsData?.quantity))) {
      this.showRoomError = true;
      this.showTotalAmount = true;
      return;
    }
    if (this.showRoomPrice !== 0 && (this.totalAmount > 500000)) {
      return;
    }
    //  }

let enryptedAadhar
if (isPlatformBrowser(this.platformId)) {
     enryptedAadhar=this.localStorage.encryptData((this.userAadharno[0]?.doc_number))
}
    // if (leadsData.razor_pay_detail?.length == 1) {
    //   // this.openSelectPaymentModal.hide();
    //   let payment_type = leadsData.razor_pay_detail[0].payment_gt_type == "CCAVENUE" ? 'ccavenue' : 'razorpay';
    //   this.paymentService.makePayment(leadsData, this.optyData, true, 'booking', null, payment_type, this.amount, enryptedAadhar);
    // }
    // else {
    //   let payament_type = this.paymentTypeForm.controls['paymentType'].value;
    //   if (payament_type) {
    //     if (leadsData.razor_pay_detail.findIndex(val => val.payment_gt_type?.toLowerCase() == payament_type) > -1) {
    //       // this.openSelectPaymentModal.hide();
    //       this.paymentService.makePayment(leadsData, this.optyData, true, 'booking', null, payament_type, this.amount,enryptedAadhar);
    //     }
    //     else {
    //       this.toastrService.error("Please select valid payment")
    //     }
    //   }

    let payload = {
      "offset": 0,
      "limit": 10,
      "lead_channel": "",
      "request_id": leadsData?.row_id
  }
    this.sub.add(
      this.apiService.getLeads(payload).subscribe({
        next: (response: any) => {
  let data = response?.data?.leads[0];
  let userData = response?.data
  if (data.razor_pay_detail?.length == 1) {
    // this.openSelectPaymentModal.hide();
    let payment_type =
      data.razor_pay_detail[0].payment_gt_type == 'CCAVENUE'
        ? 'ccavenue'
        : 'razorpay';
    this.paymentService.makePayment(
      data,
      userData,
      true,
      'booking',
      null,
      payment_type,
      this.amount,
      enryptedAadhar
    );
  } else {
    let payament_type = this.paymentTypeForm.controls['paymentType'].value;
    if (payament_type) {
      if (
        data.razor_pay_detail.findIndex(
          (val) => val.payment_gt_type?.toLowerCase() == payament_type
        ) > -1
      ) {
        // this.openSelectPaymentModal.hide();
        this.paymentService.makePayment(
          data,
          userData,
          true,
          'booking',
          null,
          payament_type,
          this.amount,
          enryptedAadhar
        );
      } else {
        this.toastrService.error('Please select valid payment');
      }
    }
  }
        },
      })
    );

    }
    //       // }


  makeFNIPayment(lead) {
    if (lead?.vas_data?.length > 0) {

      this.vasDataLocal['AnnualKms'] = lead.vas_data[0].avg_monthly_km;
      this.vasDataLocal['Exshowroomprice'] = lead.ex_showroom_price ? Math.round(lead.ex_showroom_price) : lead.product.price_range;
      this.vasDataLocal['LOB'] = lead.product.sub_lob;
      this.vasDataLocal['NoOfyears'] = lead.product.sub_lob;
      this.vasDataLocal['SubLob'] = lead.product.lob;
      this.vasDataLocal['VASBookingAmount'] = lead.vas_data[0].vas_payble_amount;
      this.vasDataLocal['VASPLAN'] = lead.vas_data[0].vas_category;
      this.vasDataLocal['VASTotalAmount'] = lead.product.sub_lob;
      this.vasDataLocal['VCNUMBER'] = lead.vas_data[0].vehicle_number;
      this.vasDataLocal['VasAvailable'] = 'YES';
      this.vasDataLocal['fuel_type'] = lead.vas_data[0].fuel_type;
      this.vasDataLocal['isViaConfigurator'] = true;
      this.vasDataLocal['terrian'] = lead.vas_data[0].terrian;
      this.vasDataLocal['vasApplication'] = lead.vas_data[0].application;
      this.vasDataLocal['id'] = lead.vas_data[0].id;
      this.vasDataLocal['recommended_quantity'] = lead.vas_data[0].recommended_quantity;

if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem(
        'VASDataProfile',
        JSON.stringify(this.vasDataLocal)
      );
    }
    }

    
      let sublob = lead.product.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (lead.product.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : lead.product.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = lead.product.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
     if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem('retryPaymentData', JSON.stringify(lead))
    }
      let route = '/lead-booking/' + sublob + '/' + lead.product.lob_seo + '/' + lead.product.ppl_seo + '/' + model + '/' + lead.product.id + '/Finance';
      let queryParams: any = {};
          if(lead.row_id){
            queryParams.row_id = lead.row_id
          }
      // this.router.navigate(['/lead-booking/' + sublob + '/' + lead.product.lob_seo + '/' + lead.product.ppl_seo + '/' + model + '/' + lead.product.id + '/Finance']);
      this.router.navigate([route], { queryParams });
    

  }
  get nativeWindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    }
  }
  getVehicle(item) {
    this.advReceived = false;
    this.showTimeLine = false;
    this.showEdd = false;
    this.ProgressBarData = []; this.ProgressBarData = [];
    if ((item.lead_channel == 'OSP_Configurator'|| item.lead_channel == 'Fleet Verse Configurator'
    ) && item.opty_status == 'C2 (Adv. Received)') {
      this.showTimeLine = true;
      let data = {
        opty_id: item.opty_id,
      }
      this.sub.add(this.apiService.getVehicleData(data).subscribe({
        next: (res: any) => {
          this.showEdd = true;
          this.ProgressBarData = res?.vehicle_edd_details;
        }
      }))
    }
  }



  pageChangeBooking(page: any) {
    this.currentPageBooking = page;
    this.orderDetailsIndex = null
    page = page - 1;
    let reqBody =
    {
      "offset": page,
      "limit": 10
    };
    this.getBookingDetails(reqBody);
  }



  moreDetails(row_id: any, index: any, flag) {

    this.flag = flag;
    if (this.orderDetailsIndex == index) {
      if (this.isSecure && flag == 'moreDetails') {
        this.showBookingList = false;
      } else if (!this.isSecure && flag == 'secure') {
        this.showBookingList = false;
      }
      else {
        this.orderDetailsIndex = null;
        this.showBookingList = true;
      }

      this.isSecure = flag != 'moreDetails' ? true : false
    } else {
      this.orderDetailsIndex = index;
      this.showBookingList = false;
      this.isSecure = flag != 'moreDetails' ? true : false
      // this.bookingData.filter((x: any) => {
      //   if (x.row_id == row_id) {
      //     this.bookingDataDeatail = x;
      //     this.dealerInfo = this.bookingDataDeatail.dealer_info;
      //   }
      // });
    }
  }
  redirect(data) {
    let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
    let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
    var currentUrl = '/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id;
    return currentUrl;
    // this.router.navigate(['/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id]);

  }
  numSequence(n: number): Array<number> {
    return Array(n);
  }
  notAllowSpace(event: any) {
    if (event.target.selectionStart === 0 && event.which === 32) {
      event.preventDefault();
    }
  }
  clevertapPayementFailed() {

    //  let baseUrl = window.location.href;
   
      try {
        //  this.cleverService.onPaymentfailed(
        // this.response?.leadInfo.leadInfo['id'],
        // "Online Transfer",
        // this.imageUrl,

        // this.response?.leadInfo.leadInfo["model"],
        // "Top Navigation",
        // baseUrl,
        // this.response?.leadInfo.leadInfo['sub_lob'],
        // this.response?.leadInfo.leadInfo['lob'],
        // this.response?.leadInfo.leadInfo['ppl'],
        // this.response?.ex_showroom_amount,
        // this.response?.booking_amount,
        // this.response?.payment_amount/10,
        //  );
      } catch { }
    
  }

  async generateChallengeToken(leadData: any) {
    if (leadData?.opty_id && leadData?.fni_begin) {
      let data = {
        "appName": "com.tatamotors.cv_online_portal",
        "crmOpportunityID": leadData?.opty_id
      }

      this.sub.add(this.apiService.getfniToken(data).subscribe({
        next: (data: any) => {

          if (data?.challengeToken) {
            if (isPlatformBrowser(this.platformId)) {
            this.localStorage.setItem('productVehicleImgUrl', JSON.stringify(leadData?.vehicle_info?.image[0]?.image_url ? leadData.vehicle_info.image[0].image_url : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/placeholder.webp'));
            }
            this.onTrackButtonClick(leadData.opty_id, this.userData.mobile_number, data?.challengeToken);
          }
          else {
            this.toastrService.warning(data?.message);
          }

        }
      }))
    }

    else {
      var element = document.getElementById('fetch_btn')
      element.click();

    }
  }

  getLeadStatus(leads?, codition?): String {
    var temp = ''
    leads.filter((x: any) => {
      if (x.opty_status == codition) {
        temp = formatDate(
          x.updated_date, "dd-MM-yyyy", "en-US");

      }

    });
    return temp;

  }
  getLeadCss(leads?, codition?): String {
    // this.activeClass = false;
    var temp = ''
    if (codition == 'C2 (Adv. Received)') {
      this.advReceived = true;
    }
    leads.filter((x: any) => {
      if (x.opty_status == codition) {
        // this.activeClass = true;
        temp = 'active';
      }
    });
    return temp;
  }
  onTrackButtonClick(optyID: any, mobileNumber: any, challengeToken: any) {
    this.openUrl = true;
    this.router.navigate(['/fni/application-overview'],
      { queryParams: { login_id: mobileNumber, opty_id: optyID, token: challengeToken } }
    );
  }
  getBookingAmount(leadData) {
    this.totalAmount = this.paymentTypeForm.value.amount * leadData.quantity + this.VasAmount
  }
  numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  close() {

    this.modalService.dismissAll();
  }
  openPopup(openForm: any) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'side-drawer'
    };
    this.modalService.open(openForm, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });
    });
  }
  openPopup2(openForm: any) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'side-drawer'
    };
    this.modalService.open(openForm, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public hasRequiredError = (controlName: string): boolean | undefined =>
  this.formErrorService.hasRequiredError(controlName, this.paymentTypeForm);

  getQUotationdata(data:any){

    let val={
      'opty_id':data.opty_id
      }
      try {
        this.sub.add(this.apiService.getQuotation(val).subscribe({
            next: (res: any) => {
              if (res?.data?.file_path != null) {
                if (isPlatformBrowser(this.platformId)) {
                  window.open(res.data.file_path[0],'_blank')
                }
              }else{

              }
            },
            error: (err:any) => {
              this.toastrService.warning("No data available")

            },
            complete: () => { }

          })
        )
      } catch (error) {

      }
    }
  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }
  getCreatedDate(createdDate:any){
    const responseDate = new Date(createdDate);
    const formattedResponseDate = responseDate.toISOString().split('T')[0];
    const targetDateString = '2024-09-10';
    const targetDate = new Date(targetDateString);
   const formattedTargetDate = targetDate.toISOString().split('T')[0];
    if (formattedResponseDate > formattedTargetDate) {
      return true;
    }
    else{
      return false;
    }
  }
  gotoFniform(data:any,optyId:any,status:any,obj:any){
    if (obj?.quantity == 1) {
  //     let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
  //     let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
  //     let queryParams: any = {};
  //     let routePath = `/lead-booking/${sublob}/${data.lob_seo}/${data.ppl_seo}/${model}/${data.id}/FinanceJourney/${dealer_code}`;
  // if (optyId) {
  //   queryParams.optyId = optyId;
  // }
  // if (status) {
  //   queryParams.status = status;
  // }
  // if (dse_loginFni) {
  //   queryParams.dse_loginFni = dse_loginFni;
  // }


  // this.router.navigate([routePath], { queryParams });
  let Dealer_code:any;
  let assignLogin:any;
  let payload = {
    "offset": 0,
    "limit": 10,
    "lead_channel": "",
    "request_id": obj?.row_id
}
  this.sub.add(
    this.apiService.getLeads(payload).subscribe({
      next: (res: any) => {
        if (res?.success) {
          Dealer_code = res?.data?.leads[0]?.dealer_info?.dealer_code || {};
          assignLogin = res?.data?.leads[0]?.solr_data[0].ASSIGN_LOGIN_s || {};
        } else {
          Dealer_code = '';
        }
      },
      error: (error: any) => {
        Dealer_code = ''
      },
      complete: () => {
        let sublob =
        data.sub_lob.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
          ? 'trucks'
          : data.sub_lob.replace(/\s/g, '-')?.toLowerCase() == 'buses'
          ? 'buses-vans'
          : data.sub_lob.replace(/\s/g, '-')?.toLowerCase();
      let model = data.model
        .replace(/\s/g, '-')
        .replace(/\//g, '-')
        .replace(/\+/g, '-')
        .replace(/\./g, '-')
        ?.toLowerCase();
      let queryParams: any = {};
      let routePath = `/lead-booking/${sublob}/${data.lob_seo}/${data.ppl_seo}/${model}/${data.id}/FinanceJourney/${Dealer_code}`;
      if (optyId) {
        queryParams.optyId = optyId;
      }
      if (status) {
        queryParams.status = status;
      }
      // if (dse_loginFni) {
      //   queryParams.dse_loginFni = dse_loginFni;
      // }
      if (assignLogin) {
        queryParams.dse_loginFni = assignLogin;
      }
      if(obj.row_id){
        queryParams.row_id = obj.row_id
      }
      this.router.navigate([routePath], { queryParams });
      }
    })
  );

    }
    else{
      this.toastrService.warning("The financing option is currently available only for individual customers with single vehicle quantity.")
    }

    // this.router.navigate(['/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id + '/FinanceJourney' + '/' + optyId+'/'+status +'/'+dse_login]);
  }
  checkPrice(ex_price:any,pricerange:any){

    const price = ex_price ? Number(ex_price) : pricerange ? Number(pricerange) : 0;

    if (price > 300000) {
      return true;
    }
    else {
      return false;
    }
  }
  getDealerInfo(vehicle_info:any,division_id:any,flag:any,index:any){
    let check =  this.orderDetailsIndex != index ? true : false
  if (check == false){
    let Payload = {
      "action_type" : "dealer_info",
      "lob":vehicle_info?.lob,
      "division_id":division_id
     };
     this.Dealer_info = {};
     this.spinner.show();
     try {
       this.sub.add(
         this.apiService.getLeadsnew(Payload).subscribe({
           next: (res: any) => {
             if (res?.success) {
               this.Dealer_info = res?.data?.dealer_info || {};
               this.spinner.hide();

             } else {
               this.Dealer_info = {};
               this.spinner.hide();
             }
           },
           error: (error: any) => {
             this.Dealer_info = {}
             this.spinner.hide();

           },
           complete: () => {
            this.spinner.hide();
           }
         })
       );
     } catch (error) {

      this.spinner.hide();
     }
  }


    }
    getLeadStatusInfo(row_id:any,index:any){
      let check =  this.orderDetailsIndex != index ? true : false
    if (check == false){
      let Payload = {
       "action_type" : "lead_status_info",
       "row_id":row_id
      };
  this.Lead_Status_info = []
  this.spinner.show();
      try {
        this.sub.add(
          this.apiService.getLeadsnew(Payload).subscribe({
            next: (res: any) => {
              if (res?.success) {
                this.Lead_Status_info = res?.data?.lead_status_info
                this.spinner.hide();
              } else {

                this.Lead_Status_info = []
                this.spinner.hide();
              }
            },
            error: (error: any) => {
              this.Lead_Status_info = []
              this.spinner.hide();
            },
            complete: () => {
              this.spinner.hide();
            }
          })
        );
      } catch (error) {
        this.spinner.hide();

      }
    }
    }
    getreviewStatus(vehicle_info:any,division_id:any,vc:any,index:any){
      let check =  this.orderDetailsIndex != index ? true : false
    if (check == false){
      let Payload = {
        "action_type" :"review_status",
        "lob":vehicle_info?.lob,
        "division_id":division_id,
        "vc":vc
      };
  this.Review_status = [];
  this.spinner.show();
      try {
        this.sub.add(
          this.apiService.getLeadsnew(Payload).subscribe({
            next: (res: any) => {
              if (res?.success) {
                this.Review_status = res?.data?.review_status
                this.spinner.hide();
              } else {
                this.Review_status = [];
                this.spinner.hide();
              }
            },
            error: (error: any) => {
              this.Review_status = [];
              this.spinner.hide();
            },
            complete: () => {
              this.spinner.hide();
            }
          })
        );
      } catch (error) {

        this.spinner.hide();
      }
    }
    }
    getrazorpaydetail(leads:any,division_id:any){
      let Payload = {
        "action_type" :"razor_pay_detail",
        "division_id":division_id,
      };
      this.RazorPayDetail=[];
      try {
        this.sub.add(
          this.apiService.getLeadsnew(Payload).subscribe({
            next: (res: any) => {
              if (res?.success) {
                let razorpay_Detail = res?.data?.razor_pay_detail;
                this.RazorPayDetail = razorpay_Detail;
                if (
                  (leads?.payment_status == 'aborted' ||
                    leads?.payment_status == 'Payment Failed' ||
                    leads?.payment_status == 'PENDING' ||
                    leads?.payment_status == 'UNBILLED') &&
                  (leads?.opty_status == 'C1 (Quote Tendered)' ||
                    leads?.opty_status == 'C1A (Papers submitted)' ||
                    leads?.opty_status == 'PENDING')
                ) {
                  this.leadData(leads,razorpay_Detail);
                } else {
                  this.refreshPaymemt(leads,razorpay_Detail);
                }
              } else {
                this.RazorPayDetail=[];
              }
            },
            error: (error: any) => {
              this.RazorPayDetail=[];
            },
            complete: () => {

            }
          })
        );
      } catch (error) {
        this.RazorPayDetail=[];
      }

    }
   getSolrData(array: any) {
    const Payload = {
      opty_id: array
    };
 
    this.solrDataArray = {};
    this.spinner.show();
    try {
      this.sub.add(
        this.apiService.getsolrdata(Payload).subscribe({
          next: (res: any) => {
            if (res?.success) {
              this.solrDataArray = res.data;
 
              const solrMap = new Map(this.solrDataArray.map((item: any) => [item.ROW_ID, item]));
 
              this.bookingData = this.bookingData.map((lead: any) => ({
                ...lead,
                solr_data: solrMap.get(lead.opty_id) || {}
              }));
 
              console.log('Merged bookingData:', this.bookingData);
              this.spinner.hide();
            } else {
              this.solrDataArray = {};
              this.spinner.hide();
            }
          },
          error: (error: any) => {
            this.solrDataArray = {};
            this.spinner.hide();
          },
          complete: () => {
            this.spinner.hide();
          }
        })
      );
    } catch (error) {
      console.error(error);
    }
  }
      isAssignLogin(array: any[], rowId: string): boolean {
        if (!Array.isArray(array) || array?.length === 0) {
          return false;
      }
        const item = array.find(obj => obj.ROW_ID === rowId);

        return item !== undefined && item.ASSIGN_LOGIN_s && item.ASSIGN_LOGIN_s.trim() !== '';
    }

    getLoyalStatement() {
    
        const rowIds = this.bookingData
          ?.filter((record: any) => record.row_id)
          .map((record: any) => record.row_id);

        let data = {
          mobile_number: this.userData.mobile_number,
          row_id: rowIds,
          transaction_type: 'ACC',
        };

        try {
          this.spinner.show();
          this.sub.add(
            this.apiService.getLoyalState(data).subscribe({
              next: (response: any) => {
                if (response.success) {
                  this.loyalPoints = response.data || [];

                  this.bookingData = this.bookingData.map((booking: any) => {
                    const loyaltyPointsForBooking = this.loyalPoints?.find(
                      (point: any) => point.order_number === booking.row_id
                    );

                    return {
                      ...booking,
                      points: loyaltyPointsForBooking?.points || 0,
                      scheme_master: loyaltyPointsForBooking?.sche_master || [],
                    };
                  });

                  // Fetch `scheme_master` from the first booking
                  const firstSchemeMaster = this.bookingData[0]

                  if (firstSchemeMaster) {
                    this.bookingData.forEach((booking: any) => {
                      const schemeMaster = booking.scheme_master?.[0] || firstSchemeMaster?.scheme_master?.[0];
                      const bonusType = schemeMaster?.scheme_bonus_type;
                      const maxValue = schemeMaster?.max_value;
                      const parameter = schemeMaster?.parameter;
                      booking.valuepoints = schemeMaster?.scheme_value
                      booking.scheme_message =
                        bonusType === 'Percentage'
                          ? `Unlock up to ${maxValue} coins on your ${parameter}!`
                          : `Unlock up to ${booking.points} coins on your ${parameter}!`;
                    });
                  } else {
                    this.messagedata = '';
                  }
                }
              },
              error: () => {
                this.toastrService.warning('Something went wrong!');
                this.bookingData = this.bookingData.map((booking: any) => ({
                  ...booking,
                  points: 0
                }));

                this.spinner.hide();
              },
              complete: () => {
                this.spinner.hide();
              },
            })
          );
        } catch (error) {
          // Add zero points to booking data in case of error
          this.bookingData = this.bookingData.map((booking: any) => ({
            ...booking,
            points: 0
          }));

          this.spinner.hide();
        }
      
    }
}
export class PaymentResponse {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}
